import { render } from "./ContactDetails.vue?vue&type=template&id=3163f5ab"
import script from "./ContactDetails.vue?vue&type=script&lang=js"
export * from "./ContactDetails.vue?vue&type=script&lang=js"

import exportComponent from "/Users/farhad/Hemsidan/fartow-se/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__